// extracted by mini-css-extract-plugin
export default {"container":"Mpesa_container__hlK4J","body":"Mpesa_body__Sa0oA","main":"Mpesa_main__hk9IL"};